import React, { useCallback } from 'react'
import { Alert } from 'components'
import { actions } from 'store'
import { useDispatch } from 'react-redux'
import { alerts } from 'keys'
import { schoolHooks } from '.'

const ExistAssessmentAlert = (props) => {
    const { accept } = props
    // const crudAffiliation = schoolHooks.useCrudAffiliation()
    const dispatch = useDispatch()

    const handleAlert = useCallback(() => {
        dispatch(actions.setAlerts({
            key: alerts.exitEditAffiliation,
            value: { open: false, props: null }
        }))
    }, [])

    const save = useCallback(() => {
        // crudAffiliation()
        handleAlert()
    }, [])

    const footerActions = React.useMemo(
        () => [
            { label: "שמירה ויציאה", variant: "danger", color: "error", action: save },
            { label: "יציאה", variant: "white", color: "thirdly4", action: () => handleAlert(false) }
        ], []
    )

    return (
        <Alert
            systemUI
            type="danger"
            title={" יצאת ללא שמירת שינויים"}
            footerActions={[]}
            handleAlert={handleAlert}
        >
            {"השינויים שביצעת לא נשמרו...."}
        </Alert>
    )
}

export default ExistAssessmentAlert